import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './loading-spinner.scss';

export function LoadingSpinner({ wrapperClassNames = null, spinnerClassNames = null }) {
  return (
    <div className={wrapperClassNames}>
      <i
        className={classnames('insider-loading-spinner icon-spinner8 d-inline-block', spinnerClassNames)}
        aria-hidden
      />
    </div>
  );
}

LoadingSpinner.propTypes = {
  wrapperClassNames: PropTypes.string,
  spinnerClassNames: PropTypes.string,
};
